/**
 * ValidationUtility.js
 * Created by calhosh on 7/9/2020.
 */

import React from 'react';
import {
	entities,
	validationFilter,
	validationTypes,
	documentTypes,
	summaryFilters,
	formBodyType,
	navigationFilters,
	documentLevelValidationTypes
} from '../../../../util/uiconstants';
import {currentResource, labels} from '../../../../util/utils';
import EllipseControl from '../../EllipsesControl/EllipsesControl';
import DropdownItem from '../../BaseComponentWrappers/MotifDropdownItem';
import Utility from '../../../../util/utilityfunctions';

/**
 * return validation counts.
 * @param {Number} headerId - headerId.
 * @param {Number} sectionId - sectionId.
 * @param {Number} bodyId - bodyId.
 * @param {Object} validationData - data to search for validations in.
 * @param {Object} validationsFilter - validation filters to apply.
 * @param {Number} documentTypeId - form document type.
 * @param {Bool} isDocumentLevelGuidedWorkFlowData - document guided work flow validation data required.
 * @param {Array} bodyIdAndBodyTypeIdData - Array containing bodyId and bodyTypeId data.
 * @returns {Object} object containing the counts of validations for the given id.
 **/
export function getValidationCountForIds(
	headerId,
	sectionId,
	bodyId,
	validationData,
	validationsFilter,
	documentTypeId,
	isDocumentLevelGuidedWorkFlowData = false,
	bodyIdAndBodyTypeIdData = []
) {
	let incompleteCount = 0,
		unresolvedCount = 0;
	const itFlowValidations = [],
		guidedWorkFlowValidations = [];

	const incompleteResponseValidationType =
		documentTypeId !== documentTypes.independenceFormIndividual
			? validationTypes.FinalizeIncompleteCanvasFromResponses
			: validationTypes.AllIncompleteResponses;

	if (headerId && sectionId && bodyId) {
		if (validationData && validationData.length > 0) {
			validationData.map((vd) => {
				vd.children.map((data) => {
					if (Number(data.validationId) === headerId) {
						data.children &&
							data.children.map((sec) => {
								if (validateEntityLevel(sec.validationTypeId, sec.validationEntityId, entities.FormSection) && Number(sec.validationId) === sectionId) {
									sec.children &&
										sec.children.map((body) => {
											if (validateEntityLevel(body.validationTypeId, body.validationEntityId, entities.FormBody) && Number(body.validationId) === bodyId) {
												if (validationsFilter === validationFilter.INCOMPLETE) {
													if (body.validationTypeId !== validationTypes.CanvasFromComments && body.validationTypeId !== validationTypes.IndependenceSubmit) {
														if (body.validationTypeId === incompleteResponseValidationType || body.validationTypeId === validationTypes.IndependenceSubmit) {
															incompleteCount = body.validationCount;
														}
														if (Utility.isDocumentTypeFit(documentTypeId)) {
															guidedWorkFlowValidation(body, guidedWorkFlowValidations);
														}
													}
												} else if (validationsFilter === validationFilter.COMMENTS) {
													if (body.validationTypeId === validationTypes.CanvasFromComments || body.validationTypeId === validationTypes.IndependenceSubmit) {
														unresolvedCount = body.validationCount;
													}
												} else {
													if (body.validationTypeId === validationTypes.CanvasFromComments) {
														unresolvedCount = body.validationCount;
													}
													if (body.validationTypeId === incompleteResponseValidationType || body.validationTypeId === validationTypes.IndependenceSubmit) {
														incompleteCount = body.validationCount;
													}
													if (body.validationTypeId === validationTypes.AllIncompleteResponses) {
														incompleteCount = body.validationCount;
													}
													if (Utility.isDocumentTypeFit(documentTypeId)) {
														guidedWorkFlowValidation(body, guidedWorkFlowValidations);
													}
												}
											}
										});
								}
							});
					}
				});
			});
		}
	} else if (headerId && sectionId) {
		if (validationData && validationData.length > 0) {
			validationData.map((vd) => {
				vd.children.map((data) => {
					if (validateEntityLevel(data.validationTypeId, data.validationEntityId, entities.FormHeader) && Number(data.validationId) === headerId) {
						data.children &&
							data.children.map((sec) => {
								if (validateEntityLevel(sec.validationTypeId, sec.validationEntityId, entities.FormSection) && Number(sec.validationId) === sectionId) {
									if (validationsFilter === validationFilter.INCOMPLETE) {
										if (sec.validationTypeId !== validationTypes.CanvasFromComments && sec.validationTypeId !== validationTypes.IndependenceSubmit) {
											if (
												sec.validationTypeId === incompleteResponseValidationType ||
												sec.validationTypeId === validationTypes.IndependenceSubmit ||
												sec.validationTypeId === validationTypes.MultiEntityWithoutIndividualProfileForm
											) {
												incompleteCount = sec.validationCount;
											}
											if (Utility.isDocumentTypeFit(documentTypeId)) {
												guidedWorkFlowValidation(sec, guidedWorkFlowValidations);
											}
										}
									} else if (validationsFilter === validationFilter.COMMENTS) {
										if (sec.validationTypeId === validationTypes.CanvasFromComments || sec.validationTypeId === validationTypes.IndependenceSubmit) {
											unresolvedCount = sec.validationCount;
										}
									} else {
										if (sec.validationTypeId === validationTypes.CanvasFromComments) {
											unresolvedCount = sec.validationCount;
										}
										if (sec.validationTypeId === incompleteResponseValidationType || sec.validationTypeId === validationTypes.IndependenceSubmit) {
											incompleteCount = sec.validationCount;
										}
										if (sec.validationTypeId === validationTypes.AllIncompleteResponses) {
											incompleteCount = sec.validationCount;
										}
										if (Utility.isDocumentTypeFit(documentTypeId)) {
											guidedWorkFlowValidation(sec, guidedWorkFlowValidations, 'section', bodyIdAndBodyTypeIdData);
										}
									}
								}
							});
					}
				});
			});
		}
	} else if (isDocumentLevelGuidedWorkFlowData) {
		if (validationData && validationData.length > 0) {
			validationData.map((data) => {
				if (validationsFilter === validationFilter.INCOMPLETE) {
					if (data.validationTypeId !== validationTypes.CanvasFromComments && data.validationTypeId !== validationTypes.IndependenceSubmit) {
						if (data.validationTypeId === incompleteResponseValidationType || data.validationTypeId === validationTypes.IndependenceSubmit) {
							incompleteCount = data.validationCount;
						}
						if (Utility.isDocumentTypeFit(documentTypeId)) {
							guidedWorkFlowValidation(data, guidedWorkFlowValidations);
						}
					}
				} else if (validationsFilter === validationFilter.COMMENTS) {
					if (data.validationTypeId === validationTypes.CanvasFromComments || data.validationTypeId === validationTypes.IndependenceSubmit) {
						unresolvedCount = data.validationCount;
					}
					if (Utility.isDocumentTypeFit(documentTypeId)) {
						guidedWorkFlowValidation(data, guidedWorkFlowValidations);
					}
				} else {
					if (data.validationTypeId === validationTypes.CanvasFromComments) {
						unresolvedCount = data.validationCount;
					}
					if (data.validationTypeId === incompleteResponseValidationType || data.validationTypeId === validationTypes.IndependenceSubmit) {
						incompleteCount = data.validationCount;
					}
					if (data.validationTypeId === validationTypes.AllIncompleteResponses) {
						incompleteCount = data.validationCount;
					}
					if (Utility.isDocumentTypeFit(documentTypeId) && !documentLevelValidationTypes.includes(data.validationTypeId)) {
						guidedWorkFlowValidation(data, guidedWorkFlowValidations);
					}
				}
			});
		}
	} else {
		if (validationData && validationData.length > 0) {
			validationData.map((vd) => {
				vd.children.map((data) => {
					if (validationsFilter === validationFilter.INCOMPLETE) {
						if (
							data.validationEntityId === entities.FormHeader &&
							Number(data.validationId) === headerId &&
							data.validationTypeId !== validationTypes.CanvasFromComments &&
							data.validationTypeId !== validationTypes.IndependenceSubmit
						) {
							if (
								data.validationTypeId === incompleteResponseValidationType ||
								data.validationTypeId === validationTypes.IndependenceSubmit ||
								data.validationTypeId === validationTypes.MultiEntityWithoutIndividualProfileForm
							) {
								incompleteCount = data.validationCount;
							}
							if (data.validationTypeId === validationTypes.AllIncompleteResponses) {
								incompleteCount = data.validationCount;
							}
							if (Utility.isDocumentTypeFit(documentTypeId) && data.validationEntityId === entities.FormHeader && Number(data.validationId) === headerId) {
								guidedWorkFlowValidation(data, guidedWorkFlowValidations);
							}
						}
					} else if (validationsFilter === validationFilter.COMMENTS) {
						if (
							data.validationEntityId === entities.FormHeader &&
							Number(data.validationId) === headerId &&
							(data.validationTypeId === validationTypes.CanvasFromComments || data.validationTypeId === validationTypes.IndependenceSubmit)
						) {
							unresolvedCount = data.validationCount;
						}
					} else {
						if (
							data.validationEntityId === entities.FormHeader &&
							Number(data.validationId) === headerId &&
							(data.validationTypeId === incompleteResponseValidationType || data.validationTypeId === validationTypes.IndependenceSubmit)
						) {
							incompleteCount = data.validationCount;
						}
						if (
							data.validationEntityId === entities.FormHeader &&
							Number(data.validationId) === headerId &&
							data.validationTypeId === validationTypes.CanvasFromComments
						) {
							unresolvedCount = data.validationCount;
						}
						if (Utility.isDocumentTypeFit(documentTypeId) && data.validationEntityId === entities.FormHeader && Number(data.validationId) === headerId) {
							guidedWorkFlowValidation(data, guidedWorkFlowValidations);
						}
					}
				});
			});
		}
	}
	return {
		incompleteCount,
		unresolvedCount,
		itFlowValidations,
		guidedWorkFlowValidations
	};
}

const validateEntityLevel = (validationTypeId, entityId, entitylevel) => {
	if (validationTypeId != validationTypes.ChangeNotSubmittedMultiEntityIndividualDocument) {
		return entityId === entitylevel;
	}
	return true;
};

export const getDocumentLevelValidationCount = (validationData, documentId, documentTypeId) => {
	let documentLevelValidation = 0;
	if (validationData && validationData.length > 0) {
		validationData.map((vd) => {
			if (documentLevelValidationTypes.includes(vd.validationTypeId) && Utility.isDocumentTypeFit(documentTypeId)) {
				documentLevelValidation += vd.validationCount;
			}
		});
	}

	return documentLevelValidation;
};

export const getValidationFilterBasedOnSummaryFilter = (filterVal) => {
	if (filterVal === summaryFilters.INCOMPLETERESPONSES) {
		return validationFilter.INCOMPLETE;
	} else if (filterVal === summaryFilters.UNRESOLVEDCOMMENTS) {
		return validationFilter.COMMENTS;
	}

	return validationFilter.NONE;
};

export const GetDocumentISA315ITFlowValidations = (validationData) => {
	const isa315ItFlowDocumentExistingValidations = [];
	if (validationData && validationData.length > 0) {
		validationData.map((vd) => {
			if (
				vd.validationTypeId === validationTypes.ITSPNotDeletedWhenCorrespondingBodyIsNotDisplayed ||
				vd.validationTypeId === validationTypes.ITGCNotDeletedWhenCorrespondingBodyIsNotDisplayed ||
				vd.validationTypeId === validationTypes.ITRiskIsNotDeletedWhenCorrespondingBodyIsNotDisplayed ||
				vd.validationTypeId === validationTypes.ITGCWithHasItControlTestingIsOneExistsWhenCorrespondingBodyIsNotDisplayed ||
				vd.validationTypeId === validationTypes.AnyITDMorITACWithHasControlTestingIsOneExistsAndFormBodyTypeId111IsNotDisplayed ||
				vd.validationTypeId === validationTypes.ITAppWithoutAtLeastOneRelatedITProcess ||
				vd.validationTypeId === validationTypes.ValidationTypeID237 ||
				vd.validationTypeId === validationTypes.ITControlApproachType1ExecutionType2WithoutITRisk
			) {
				isa315ITFlowValidation(vd, isa315ItFlowDocumentExistingValidations, true);
			}
		});
	}

	return isa315ItFlowDocumentExistingValidations;
};

export const GetITFlowValidationCount = (isa315ITFlowValidationForEntity) => {
	return isa315ITFlowValidationForEntity && isa315ITFlowValidationForEntity.length > 0
		? isa315ITFlowValidationForEntity.map((item) => item.validationCount).reduce((prev, next) => prev + next)
		: 0;
};

export const GetGuidedWorkFlowValidationCount = (guidedWorkFlowValidationForEntity) => {
	return guidedWorkFlowValidationForEntity && guidedWorkFlowValidationForEntity.length > 0
		? guidedWorkFlowValidationForEntity.map((item) => item.validationCount).reduce((prev, next) => prev + next)
		: 0;
};

const isa315ITFlowValidation = (data, itFlowValidations, isDocumentLevel) => {
	if (data.validationTypeId === validationTypes.SCOTWithoutITApplicationsWhereHasNoITApplicationIsZero) {
		setIsa315ITFlowValidations(itFlowValidations, validationTypes.SCOTWithoutITApplicationsWhereHasNoITApplicationIsZero, data.validationCount);
	}

	if (data.validationTypeId === validationTypes.ITDMorITACWithNoRelatedITApplication) {
		setIsa315ITFlowValidations(itFlowValidations, validationTypes.ITDMorITACWithNoRelatedITApplication, data.validationCount);
	}

	if (data.validationTypeId === validationTypes.SCOTWithHasNoITApplicationHasITDMOrAppControls) {
		setIsa315ITFlowValidations(itFlowValidations, validationTypes.SCOTWithHasNoITApplicationHasITDMOrAppControls, data.validationCount);
	}

	if (data.validationTypeId === validationTypes.ITAppWithoutAtLeastOneRelatedITProcess) {
		setIsa315ITFlowValidations(itFlowValidations, validationTypes.ITAppWithoutAtLeastOneRelatedITProcess, data.validationCount);
	}

	if (data.validationTypeId === validationTypes.ITProcessHasNoRelatedITApplication) {
		setIsa315ITFlowValidations(itFlowValidations, validationTypes.ITProcessHasNoRelatedITApplication, data.validationCount);
	}

	if (data.validationTypeId === validationTypes.ITProcessWithNoITRiskWhereThereIsAITACOrITDMRelatedToITApplication) {
		setIsa315ITFlowValidations(itFlowValidations, validationTypes.ITProcessWithNoITRiskWhereThereIsAITACOrITDMRelatedToITApplication, data.validationCount);
	}

	if (data.validationTypeId === validationTypes.ITRiskHasNoITGCIsZeroHasNoRelatedITGC) {
		setIsa315ITFlowValidations(itFlowValidations, validationTypes.ITRiskHasNoITGCIsZeroHasNoRelatedITGC, data.validationCount);
	}

	if (data.validationTypeId === validationTypes.ValidationTypeID237) {
		setIsa315ITFlowValidations(itFlowValidations, validationTypes.ValidationTypeID237, data.validationCount);
	}

	if (data.validationTypeId === validationTypes.ITControlApproachType1ExecutionType2WithoutITRisk) {
		setIsa315ITFlowValidations(itFlowValidations, validationTypes.ITControlApproachType1ExecutionType2WithoutITRisk, data.validationCount);
	}

	if (data.validationTypeId === validationTypes.ITGCHasNoRelatedITRiskOrIsRelatedToITRiskWhereHasNoITCGIsOne) {
		setIsa315ITFlowValidations(itFlowValidations, validationTypes.ITGCHasNoRelatedITRiskOrIsRelatedToITRiskWhereHasNoITCGIsOne, data.validationCount);
	}

	if (data.validationTypeId === validationTypes.ITGCWithoutASelectedDesignEffectiveness) {
		setIsa315ITFlowValidations(itFlowValidations, validationTypes.ITGCWithoutASelectedDesignEffectiveness, data.validationCount);
	}

	if (data.validationTypeId === validationTypes.ITSPHasNorelatedITRisk) {
		setIsa315ITFlowValidations(itFlowValidations, validationTypes.ITSPHasNorelatedITRisk, data.validationCount);
	}

	if (isDocumentLevel) {
		if (data.validationTypeId === validationTypes.ITRiskIsNotDeletedWhenCorrespondingBodyIsNotDisplayed) {
			setIsa315ITFlowValidations(itFlowValidations, validationTypes.ITRiskIsNotDeletedWhenCorrespondingBodyIsNotDisplayed, data.validationCount);
		}

		if (data.validationTypeId === validationTypes.ITGCNotDeletedWhenCorrespondingBodyIsNotDisplayed) {
			setIsa315ITFlowValidations(itFlowValidations, validationTypes.ITGCNotDeletedWhenCorrespondingBodyIsNotDisplayed, data.validationCount);
		}

		if (data.validationTypeId === validationTypes.ITGCWithHasItControlTestingIsOneExistsWhenCorrespondingBodyIsNotDisplayed) {
			setIsa315ITFlowValidations(
				itFlowValidations,
				validationTypes.ITGCWithHasItControlTestingIsOneExistsWhenCorrespondingBodyIsNotDisplayed,
				data.validationCount
			);
		}

		if (data.validationTypeId === validationTypes.ITSPNotDeletedWhenCorrespondingBodyIsNotDisplayed) {
			setIsa315ITFlowValidations(itFlowValidations, validationTypes.ITSPNotDeletedWhenCorrespondingBodyIsNotDisplayed, data.validationCount);
		}

		if (data.validationTypeId === validationTypes.AnyITDMorITACWithHasControlTestingIsOneExistsAndFormBodyTypeId111IsNotDisplayed) {
			setIsa315ITFlowValidations(
				itFlowValidations,
				validationTypes.AnyITDMorITACWithHasControlTestingIsOneExistsAndFormBodyTypeId111IsNotDisplayed,
				data.validationCount
			);
		}
	}

	return itFlowValidations;
};

const setGuidedWorkFlowValidations = (
	guidedWorkFlowValidations,
	validationTypeId,
	countOfValidation,
	validationData,
	displayLevel,
	bodyIdAndBodyTypeIdData
) => {
	if (
		displayLevel === 'section' &&
		(validationTypeId === validationTypes?.DocumentUploadMissingRequiredPICEQRSignOffs ||
			validationTypeId === validationTypes?.DocumentUploadMissingRequiredPICEQRSignOffRequirements ||
			validationTypeId === validationTypes?.DocumentUploadMissingPreparerOrReviewerSignOffs)
	) {
		const sectionValidationData = validationData?.children;
		setSectionPICEQRBodiesValidations(sectionValidationData, bodyIdAndBodyTypeIdData, guidedWorkFlowValidations, validationTypeId);
	} else if (guidedWorkFlowValidations.filter((d) => d.validationId === validationTypeId).length === 0) {
		guidedWorkFlowValidations.push({validationId: validationTypeId, validationCount: countOfValidation});
	} else {
		guidedWorkFlowValidations.filter((d) => d.validationId === validationTypeId)[0].validationCount += countOfValidation;
	}
};

const guidedWorkFlowValidation = (data, guidedWorkFlowValidations, displayLevel, bodyIdAndBodyTypeIdData) => {
	const guidedWorkFlowValidationWithCountOne = [
		validationTypes.IncompleteMeasurementBasisForecastAmount,
		validationTypes.IncompleteMeasurementBasisForecastAmountRationale,
		validationTypes.IncompleteMeasurementBasisAdjustedAmount,
		validationTypes.IncompletePlanningMateriality,
		validationTypes.PlanningMaterialityGreaterThanMaximumAmount,
		validationTypes.IncompletePlanningMaterialityRationale,
		validationTypes.IncompleteTolerableError,
		validationTypes.TENotWithinRangeOfAllowedValues,
		validationTypes.IncompleteTolerableErrorRationale,
		validationTypes.IncompleteSAD,
		validationTypes.SADGreaterThanMaximum,
		validationTypes.IncompleteSADRationale,
		validationTypes.IncompletePACESelection
	];

	const commonValidationTypes = [
		validationTypes.FinalizeIncompleteCanvasFromResponses,
		validationTypes.CanvasFromComments,
		validationTypes.AllIncompleteResponses
	];

	if (!commonValidationTypes.includes(data.validationTypeId)) {
		if (guidedWorkFlowValidationWithCountOne.includes(data.validationTypeId)) {
			guidedWorkFlowValidations.push({validationId: data.validationTypeId, validationCount: 1});
		} else {
			setGuidedWorkFlowValidations(guidedWorkFlowValidations, data.validationTypeId, data.validationCount, data, displayLevel, bodyIdAndBodyTypeIdData);
		}
	}

	return guidedWorkFlowValidations;
};

export const sortedISA315ITFlowSortedValidations = (itFlowExistingValidations) => {
	const itFlowSortedValidations = [91, 84, 94, 78, 81, 82, 83, 79, 89, 80, 87, 86, 89, 88, 85, 93, 237, 238];
	const sortedItFlowValidationForEntity = [];
	if (itFlowExistingValidations && itFlowExistingValidations.length > 0) {
		itFlowSortedValidations.map((t) => {
			itFlowExistingValidations.map((x) => {
				if (x.validationId === t) {
					if (sortedItFlowValidationForEntity.filter((z) => z.validationId === x.validationId).length === 0) {
						sortedItFlowValidationForEntity.push({validationId: x.validationId, validationCount: x.validationCount});
					}
				}
			});
		});
	}

	return sortedItFlowValidationForEntity;
};

export const sortedGuidedWorkFlowValidations = (guidedWorkFlowExistingValidations) => {
	const guidedWorkFlowSortedValidationIDs = [
		71, 78, 79, 80, 81, 82, 83, 84, 89, 91, 94, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 129, 130, 131, 132, 133, 134, 135, 136,
		137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 168,
		169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199,
		200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 230, 231,
		233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247
	];

	const sortedGuidedFlowValidationForEntity = [];

	if (guidedWorkFlowExistingValidations && guidedWorkFlowExistingValidations.length > 0) {
		guidedWorkFlowSortedValidationIDs.map((t) => {
			guidedWorkFlowExistingValidations.map((x) => {
				if (x.validationId === t) {
					if (sortedGuidedFlowValidationForEntity.filter((z) => z.validationId === x.validationId).length === 0) {
						sortedGuidedFlowValidationForEntity.push({
							validationId: x.validationId,
							validationCount: x.validationCount,
							bodyTypeId: x?.bodyTypeId
						});
					} else if (
						x?.validationId === validationTypes?.DocumentUploadMissingRequiredPICEQRSignOffs ||
						x?.validationId === validationTypes?.DocumentUploadMissingRequiredPICEQRSignOffRequirements ||
						x?.validationId === validationTypes?.DocumentUploadMissingPreparerOrReviewerSignOffs
					) {
						sortedGuidedFlowValidationForEntity.push({
							validationId: x?.validationId,
							validationCount: x?.validationCount,
							bodyTypeId: x?.bodyTypeId
						});
					}
				}
			});
		});
	}

	return sortedGuidedFlowValidationForEntity;
};

const setIsa315ITFlowValidations = (itFlowValidations, validationTypeId, countOfValidation) => {
	if (itFlowValidations.filter((d) => d.validationId === validationTypeId).length === 0) {
		itFlowValidations.push({validationId: validationTypeId, validationCount: countOfValidation});
	} else {
		itFlowValidations.filter((d) => d.validationId === validationTypeId)[0].validationCount += countOfValidation;
	}
};

/**
 * return validation counts.
 * @param {Array} validations - Validations collection.
 * @param {Number} validationSummaryType - Validation type.
 *  @returns {Array} Validations for the given type.
 **/
export function getValidationsByGroupType(validations, validationSummaryType) {
	if (validations) {
		return validations.filter((v) => {
			if (validationSummaryType === summaryFilters.INCOMPLETERESPONSES) {
				return v.validationTypeId !== validationTypes.CanvasFromComments;
			} else if (validationSummaryType === summaryFilters.UNRESOLVEDCOMMENTS) {
				return v.validationTypeId === validationTypes.CanvasFromComments;
			}
		});
	}
}

/**
 * return validation counts.
 * @param {Array} validations - Validations collection.
 * @param {Number} filterValue - filterValue.
 *  @returns {Array} Validations for the given type.
 **/
export function getValidationsByFilterDropdown(validations, filterValue) {
	if (validations) {
		return validations.filter((v) => {
			if (filterValue === navigationFilters.INCOMPLETERESPONSES) {
				return v.validationTypeId === validationTypes.FinalizeIncompleteCanvasFromResponses;
			} else if (filterValue === navigationFilters.UNRESOLVEDCOMMENTS) {
				return v.validationTypeId === validationTypes.CanvasFromComments;
			}
		});
	}
}

/**
 * return validation counts.
 * @param {Array} validations - Validations collection.
 * @param {Number} validationType - Validation type.
 *  @returns {Array} Validations for the given type.
 **/
export function getValidationsByValidationGroupType(validations, validationType) {
	if (validations) {
		return validations.filter((v) => {
			if (validationType === validationFilter.INCOMPLETE) {
				return v.validationTypeId !== validationTypes.CanvasFromComments;
			} else if (validationType === validationFilter.COMMENTS) {
				return v.validationTypeId === validationTypes.CanvasFromComments;
			}
		});
	}
}
export const itFlowValidationsToolTip = (validation, onValidationClick, isReadOnly) => {
	const currentResouceLabel = currentResource.ISA315ITFlowValidationTypeResourceMapping.find((t) => t.validationId === validation.validationId)?.label;

	const isClickable = [
		validationTypes.ITSPNotDeletedWhenCorrespondingBodyIsNotDisplayed,
		validationTypes.ITGCNotDeletedWhenCorrespondingBodyIsNotDisplayed,
		validationTypes.ITRiskIsNotDeletedWhenCorrespondingBodyIsNotDisplayed,
		validationTypes.ITGCHasNoRelatedITRiskOrIsRelatedToITRiskWhereHasNoITCGIsOne,
		validationTypes.ITAppWithoutAtLeastOneRelatedITProcess,
		validationTypes.ITProcessHasNoRelatedITApplication,
		validationTypes.ITProcessWithNoITRiskWhereThereIsAITACOrITDMRelatedToITApplication,
		validationTypes.ITRiskHasNoITGCIsZeroHasNoRelatedITGC,
		validationTypes.ITGCWithHasItControlTestingIsOneExistsWhenCorrespondingBodyIsNotDisplayed,
		validationTypes.ValidationTypeID237,
		validationTypes.ITControlApproachType1ExecutionType2WithoutITRisk
	].includes(validation.validationId);

	const onClick = isClickable ? () => !isReadOnly && onValidationClick && onValidationClick(currentResouceLabel) : undefined;
	return (
		<section className={`validationToolTipContainer ${isReadOnly ? 'validationToolTipContainerDisabled' : ''}`}>
			<section className={`ToolTipValidationName ${isClickable ? 'cursorPointer' : ''}`} onClick={onClick}>
				<EllipseControl content={currentResouceLabel} id={''} tooltip={currentResouceLabel} displayId={''} noOfLines={1} />
			</section>
			<section className={`ToolTipValidationCount ${isClickable ? 'cursorPointer' : ''}`} onClick={onClick}>
				<EllipseControl content={validation.validationCount} id={''} tooltip={validation.validationCount} displayId={''} noOfLines={1} />
			</section>
		</section>
	);
};

export const itFlowValidations = (validation, onValidationClick, isReadOnly) => {
	return (
		<DropdownItem
			className={`validationDropdownContainer ${isReadOnly ? 'validationDropdownContainerDisabled' : ''}`}
			children={
				<>
					{validation.validationId === validationTypes.ITSPNotDeletedWhenCorrespondingBodyIsNotDisplayed ||
					validation.validationId === validationTypes.ITGCNotDeletedWhenCorrespondingBodyIsNotDisplayed ||
					validation.validationId === validationTypes.ITRiskIsNotDeletedWhenCorrespondingBodyIsNotDisplayed ||
					validation.validationId === validationTypes.ITGCHasNoRelatedITRiskOrIsRelatedToITRiskWhereHasNoITCGIsOne ||
					validation.validationId === validationTypes.ITAppWithoutAtLeastOneRelatedITProcess ||
					validation.validationId === validationTypes.ITProcessHasNoRelatedITApplication ||
					validation.validationId === validationTypes.ITProcessWithNoITRiskWhereThereIsAITACOrITDMRelatedToITApplication ||
					validation.validationId === validationTypes.ITRiskHasNoITGCIsZeroHasNoRelatedITGC ||
					validation.validationId === validationTypes.ITGCWithHasItControlTestingIsOneExistsWhenCorrespondingBodyIsNotDisplayed ||
					validation.validationId === validationTypes.ValidationTypeID237 ||
					validation.validationId === validationTypes.ITControlApproachType1ExecutionType2WithoutITRisk ? (
						<section
							className="dropdownValidationName cursorPointer"
							onClick={() =>
								!isReadOnly &&
								onValidationClick &&
								onValidationClick(currentResource.ISA315ITFlowValidationTypeResourceMapping.find((t) => t.validationId === validation.validationId).label)
							}
						>
							<EllipseControl
								content={currentResource.ISA315ITFlowValidationTypeResourceMapping.find((t) => t.validationId === validation.validationId).label}
								id={''}
								tooltip={currentResource.ISA315ITFlowValidationTypeResourceMapping.find((t) => t.validationId === validation.validationId).label}
								displayId={''}
								noOfLines={1}
							/>
						</section>
					) : (
						<section className="dropdownValidationName">
							<EllipseControl
								content={currentResource.ISA315ITFlowValidationTypeResourceMapping.find((t) => t.validationId === validation.validationId).label}
								id={''}
								tooltip={currentResource.ISA315ITFlowValidationTypeResourceMapping.find((t) => t.validationId === validation.validationId).label}
								displayId={''}
								noOfLines={1}
							/>
						</section>
					)}
					<section className="dropdownValidationCount">
						<EllipseControl content={validation.validationCount} id={''} tooltip={validation.validationCount} displayId={''} noOfLines={1} />
					</section>
				</>
			}
		/>
	);
};

export const guidedWorkFlowValidationsDisplayToolTip = (validation, isReadOnly, onClick, displayFor, bodyTypeId) => {
	let validationLabel = currentResource.GuidedWorkFlowValidationTypeResourceMapping.find((t) => t.validationId === validation.validationId)?.label;

	if (
		validation?.validationId === validationTypes?.DocumentUploadMissingRequiredPICEQRSignOffs ||
		validation?.validationId === validationTypes?.DocumentUploadMissingRequiredPICEQRSignOffRequirements ||
		validation?.validationId === validationTypes?.DocumentUploadMissingPreparerOrReviewerSignOffs
	) {
		if (displayFor === 'body') {
			validationLabel = setValidationLabelForPICEQRBodies(validation?.validationId, bodyTypeId);
		} else if (displayFor === 'section') {
			validationLabel = setValidationLabelForPICEQRBodies(validation?.validationId, validation?.bodyTypeId);
		}
	}

	const ifMissingDocumentModalApplicable = [
		validationTypes.AccountWithoutIndividualRiskAssessmentForm,
		validationTypes.EstimateWithoutIndividualEstimateForm,
		validationTypes.AccountWithoutIndividualAnalyticForm
	].includes(validation.validationId);

	const isClickableValidation =
		displayFor === 'body' &&
		(validation.validationId === validationTypes.AccountWithoutIndividualRiskAssessmentForm ||
			validation.validationId === validationTypes.AccountWithoutIndividualAnalyticForm);
	return (
		<section
			className={`validationToolTipContainer ${
				isReadOnly || !isClickableValidation ? 'validationToolTipContainerDisabled' : ''
			} ${isReadOnly && ifMissingDocumentModalApplicable ? 'missingvalidationToolTipContainer' : ''}`}
			onClick={() => (!isReadOnly && ifMissingDocumentModalApplicable ? onClick() : {})}
		>
			<section className={`ToolTipValidationName ${isReadOnly ? 'disabled' : ''}`}>
				<EllipseControl
					disabled={isReadOnly}
					content={validation.validationCount > 1 ? validationLabel?.replaceAll('{0}', 's') : validationLabel?.replaceAll('{0}', '')}
					id={''}
					tooltip={validation.validationCount > 1 ? validationLabel?.replaceAll('{0}', 's') : validationLabel?.replaceAll('{0}', '')}
					displayId={''}
					noOfLines={2}
				/>
			</section>
			<section className="ToolTipValidationCount">
				<EllipseControl disabled={isReadOnly} content={validation.validationCount} tooltip={validation.validationCount} noOfLines={1} />
			</section>
		</section>
	);
};
export const guidedWorkFlowValidationsDisplay = (validation, isReadOnly, onClick, displayFor, bodyTypeId) => {
	let validationLabel = currentResource.GuidedWorkFlowValidationTypeResourceMapping.find((t) => t.validationId === validation.validationId)?.label;

	if (
		validation?.validationId === validationTypes?.DocumentUploadMissingRequiredPICEQRSignOffs ||
		validation?.validationId === validationTypes?.DocumentUploadMissingRequiredPICEQRSignOffRequirements ||
		validation?.validationId === validationTypes?.DocumentUploadMissingPreparerOrReviewerSignOffs
	) {
		if (displayFor === 'body') {
			validationLabel = setValidationLabelForPICEQRBodies(validation?.validationId, bodyTypeId);
		} else if (displayFor === 'section') {
			validationLabel = setValidationLabelForPICEQRBodies(validation?.validationId, validation?.bodyTypeId);
		}
	}

	const ifMissingDocumentModalApplicable = [
		validationTypes.AccountWithoutIndividualRiskAssessmentForm,
		validationTypes.EstimateWithoutIndividualEstimateForm,
		validationTypes.AccountWithoutIndividualAnalyticForm
	].includes(validation.validationId);

	const isClickableValidation =
		displayFor === 'body' &&
		(validation.validationId === validationTypes.AccountWithoutIndividualRiskAssessmentForm ||
			validation.validationId === validationTypes.AccountWithoutIndividualAnalyticForm);

	return (
		<DropdownItem
			className={`validationDropdownContainer ${
				isReadOnly || !isClickableValidation ? 'validationDropdownContainerDisabled' : ''
			} ${isReadOnly && ifMissingDocumentModalApplicable ? 'missingvalidationDropdownContainer' : ''}`}
			onClick={() => (!isReadOnly && ifMissingDocumentModalApplicable ? onClick() : {})}
			children={
				<>
					<section className={`dropdownValidationName ${isReadOnly ? 'disabled' : ''}`}>
						<EllipseControl
							disabled={isReadOnly}
							content={validation.validationCount > 1 ? validationLabel?.replaceAll('{0}', 's') : validationLabel?.replaceAll('{0}', '')}
							id={''}
							tooltip={validation.validationCount > 1 ? validationLabel?.replaceAll('{0}', 's') : validationLabel?.replaceAll('{0}', '')}
							displayId={''}
							noOfLines={2}
						/>
					</section>
					<section className="dropdownValidationCount">
						<EllipseControl disabled={isReadOnly} content={validation.validationCount} tooltip={validation.validationCount} noOfLines={1} />
					</section>
				</>
			}
		/>
	);
};

const setSectionPICEQRBodiesValidations = (sectionValidationData, bodyIdAndBodyTypeIdData, guidedWorkFlowValidations, validationTypeId) => {
	sectionValidationData?.map((val) => {
		const bodyId = val?.validationId;
		const bodyTypeId = bodyIdAndBodyTypeIdData?.find((x) => x.id == bodyId)?.bodyTypeId;
		if (val?.validationTypeId === validationTypeId) {
			guidedWorkFlowValidations.push({
				validationId: val?.validationTypeId,
				validationCount: val?.validationCount,
				bodyTypeId: bodyTypeId
			});
		}
	});
};

const setValidationLabelForPICEQRBodies = (validationId, bodyTypeId) => {
	if (validationId === validationTypes?.DocumentUploadMissingRequiredPICEQRSignOffs) {
		switch (bodyTypeId) {
			case formBodyType?.DocumentUploadPICApprovalRequired:
				return labels.evidenceMissingPICSignoffs;
			case formBodyType?.DocumentUploadEQRApprovalRequired:
				return labels.evidenceMissingEQRSignoffs;
			case formBodyType?.DocumentUploadPICEQRApprovalRequired:
				return labels.evidenceMissingPICEQRSignoffs;
		}
	} else if (validationId === validationTypes?.DocumentUploadMissingRequiredPICEQRSignOffRequirements) {
		switch (bodyTypeId) {
			case formBodyType?.DocumentUploadPICApprovalRequired:
				return labels.evidenceMissingPICSignoffRequirements;
			case formBodyType?.DocumentUploadEQRApprovalRequired:
				return labels.evidenceMissingEQRSignoffRequirements;
			case formBodyType?.DocumentUploadPICEQRApprovalRequired:
				return labels.evidenceMissingPICEQRSignoffRequirements;
		}
	} else if (validationId === validationTypes?.DocumentUploadMissingPreparerOrReviewerSignOffs) {
		switch (bodyTypeId) {
			case formBodyType?.DocumentUploadAnyApprovalRequired:
				return labels.evidenceMissingPreparerOrReviwerSignoffs;
		}
	}
};
